import vertical from './vertical.json';
import syteProductType from './syte-product-types.json';

export const en = {
  vertical,
  syteProductType,
};
